export default __webpack_public_path__ + "static/media/calendar.8b1fff8d.svg";